export const SUBSCRIPTION_PLAN_FREE = "BASIC";
export const SUBSCRIPTION_PLAN_STARTER = "STARTER";
export const SUBSCRIPTION_PLAN_PREMIUM = "PREMIUM";
export const SUBSCRIPTION_PLAN_BUSINESS = "BUSINESS";
export const SUBSCRIPTION_PLAN_ENTERPRISE = "ENTERPRISE";
export const DEFAULT_SUBSCRIPTION_PLANS = [SUBSCRIPTION_PLAN_FREE, SUBSCRIPTION_PLAN_STARTER, SUBSCRIPTION_PLAN_PREMIUM, SUBSCRIPTION_PLAN_BUSINESS];